import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormFieldType } from '../types';
import { useTranslation } from 'react-i18next';

export const InputField = ({ title, input, error, ...rest }: FormFieldType) => {
	const { t } = useTranslation();
	return (
		<FormGroup hidden={rest.hidden}>
			<Label
				htmlFor={input.name}
				className='form-group-label'
			>
				{title}
				{rest.required && <span className='required'>*required</span>}
			</Label>
			<Input
				className={error ? 'form-control error' : 'form-control'}
				{...rest}
				name={input.name}
				onChange={input.onChange}
				onBlur={input.onBlur}
				innerRef={input.ref}
				title={error && t(error.message || 'This field is required')}
				onInput={input.onChange}
			/>
			{error && (
				<div className='mt-1 mx-5'>
					<span className='signup-validation-msg'>
						{t(error.message || 'This field is required.')}
					</span>
				</div>
			)}
		</FormGroup>
	);
};
